<template>
  <div class="login">
    <!--
    <div class="">
      <h3>注册</h3>
    </div>-->
    <el-tabs type="card" v-model="registeredType" @tab-click="handleTabClick">
      <el-tab-pane
        label="手机注册"
        name="phone"
        v-if="registeredType == 'phone'"
      >
        <el-form
          class="login-form level"
          ref="loginForm"
          :model="form"
          :rules="baseRules"
        >
          <el-form-item prop="user">
            <p class="label">
              <i class="iconfont iconshouji"></i>
              <label>手机号码</label>
            </p>
            <el-input
              v-model="form.user"
              placeholder="请输入手机号码"
            ></el-input>
            <span class="overseasText" @click="overseasRegisterMail"
              >海外用户？点这里 ></span
            >
          </el-form-item>
          <el-form-item prop="captcha">
            <p class="label">
              <i class="iconfont iconyanzhengma"></i>
              <label>验证码</label>
            </p>
            <el-input v-model="form.captcha" placeholder="验证码"></el-input>
            <img
              style="height: 32px; width: 96px; border-radius: 4px"
              alt="点击刷新"
              title="点击刷新"
              class="pointer"
              :src="codeUrl"
              @click="refreshCode"
            />
          </el-form-item>

          <el-form-item prop="verCode">
            <p class="label">
              <i class="iconfont iconduanxinma"></i>
              <label>短信码</label>
            </p>
            <el-input
              max="6"
              v-model="form.verCode"
              placeholder="请输入短信码"
            ></el-input>
            <div class="code" @click="sendCode" v-if="!isSendCode">
              发送手机验证码
            </div>
            <div class="code" v-else>{{ count }}S后重发</div>
          </el-form-item>
          <el-form-item prop="password">
            <p class="label">
              <i class="iconfont iconmima1"></i>
              <label>密码</label>
            </p>
            <el-input
              type="password"
              v-model="form.password"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item prop="passwordConfirm">
            <p class="label">
              <i class="iconfont iconmima1"></i>
              <label>确认密码</label>
            </p>
            <el-input
              type="password"
              v-model="form.passwordConfirm"
              placeholder="请再次输入密码"
              @keyup.enter.native="submitRegister"
            ></el-input>
          </el-form-item>
          <el-form-item prop="sign_up_hidden_faiUuid">
            <p class="label">
              <i class="iconfont iconwodeyaoqing"></i>
              <label>邀请码</label>
            </p>
            <el-input
              v-model="form.sign_up_hidden_faiUuid"
              placeholder="非必填，如无请留空即可"
            ></el-input>
          </el-form-item>
          <el-form :inline="true">
            <el-form-item class="btn">
              <a class="btn-black" @click="submitRegister">注册</a>
            </el-form-item>
            <el-form-item class="btn">
              <a class="btn-border" @click="goBack">
                <i class="iconfont iconyonghu"></i>
                <span>返回登录</span>
              </a>
            </el-form-item>
          </el-form>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="Email Sign up" name="email" v-else>
        <el-form
          class="login-form level"
          ref="loginForm"
          :model="form"
          :rules="emailRules"
        >
          <el-form-item prop="user">
            <p class="label">
              <i class="iconfont iconduanxinma"></i>
              <label>Email</label>
            </p>
            <el-input
              v-model="form.user"
              placeholder="Please input Email"
            ></el-input>
          </el-form-item>
          <el-form-item prop="captcha">
            <p class="label">
              <i class="iconfont iconyanzhengma"></i>
              <label>Captcha</label>
            </p>
            <el-input v-model="form.captcha" placeholder="Captcha"></el-input>
            <img
              style="height: 32px; width: 96px; border-radius: 4px margin-right: 20px"
              alt="Click Refresh"
              title="Refresh"
              class="pointer"
              :src="codeUrl"
              @click="refreshCode"
            />
          </el-form-item>

          <el-form-item prop="verCode">
            <p class="label">
              <i class="iconfont iconduanxinma"></i>
              <label>EmailCode</label>
            </p>
            <el-input
              max="6"
              v-model="form.verCode"
              placeholder="Please input EmailCode"
            ></el-input>
            <div class="code" @click="sendCode" v-if="!isSendCode">
              Send EmailCode
            </div>
            <div class="code" v-else>{{ count }}S Resend</div>
          </el-form-item>
          <el-form-item prop="password">
            <p class="label">
              <i class="iconfont iconmima1"></i>
              <label>Password</label>
            </p>
            <el-input
              type="password"
              v-model="form.password"
              placeholder="Please input password"
            ></el-input>
          </el-form-item>
          <el-form-item prop="passwordConfirm">
            <p class="label">
              <i class="iconfont iconmima1"></i>
              <label>Confirm</label>
            </p>
            <el-input
              type="password"
              v-model="form.passwordConfirm"
              placeholder="Please input Password again"
              @keyup.enter.native="submitRegister"
            ></el-input>
          </el-form-item>
          <el-form-item prop="sign_up_hidden_faiUuid">
            <p class="label">
              <i class="iconfont iconwodeyaoqing"></i>
              <label>InviteCode</label>
            </p>
            <el-input
              v-model="form.sign_up_hidden_faiUuid"
              placeholder="not required"
            ></el-input>
          </el-form-item>
          <el-form :inline="true">
            <el-form-item class="btn">
              <a class="btn-black" @click="submitRegister">Sign up</a>
            </el-form-item>
            <el-form-item class="btn">
              <a class="btn-border" @click="goBack">
                <i class="iconfont iconyonghu"></i>
                <span>Sign in</span>
              </a>
            </el-form-item>
          </el-form>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  signUp,
  getVerificationCode,
  checkCaptcha,
  getCaptcha,
} from "@/api/auth";
import regexJs from "@/utils/regex";
import { message } from "@/utils/resetMessage";

// 发送验证码倒计时
const COUNTDOWN_TOTAL = 120;

export default {
  computed: {
    updateSendCodeCountState() {
      return this.$store.state.common.sendCodeCount;
    },
  },
  data() {
    return {
      timeInterval: null,
      count: COUNTDOWN_TOTAL,
      isSendCode: false,
      registeredType: "phone",
      form: {
        user: "",
        password: "",
        captcha: "",
        passwordConfirm: "",
        sign_up_hidden_faiUuid: this.$route.query.faiUuid,
        verCode: "",
        type: 1,
      },
      codeUrl: "",
      uuid: "",
      baseRules: {
        user: [
          { required: true, message: "please input phone", trigger: "blur" },
        ],
        captcha: [
          { required: true, message: "Please input Captcha", trigger: "blur" },
        ],
        password: [
          { required: true, message: "please input password", trigger: "blur" },
        ],
        passwordConfirm: [
          {
            required: true,
            message: "please input password again",
            trigger: "blur",
          },
        ],
        verCode: [
          {
            required: true,
            message: "please input phoneCode",
            trigger: "blur",
          },
        ],
      },
      emailRules: {
        user: [
          { required: true, message: "Please input Email", trigger: "blur" },
        ],
        captcha: [
          { required: true, message: "Please input Captcha", trigger: "blur" },
        ],
        password: [
          { required: true, message: "Please input Password", trigger: "blur" },
        ],
        passwordConfirm: [
          {
            required: true,
            message: "Please input Password again",
            trigger: "blur",
          },
        ],
        verCode: [
          {
            required: true,
            message: "Please input EmailCode",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.overseasRegisterMail();

    const savedCount = this.$store.state.common.sendCodeCount;
    if (savedCount !== COUNTDOWN_TOTAL) {
      this.count = savedCount;
      this.isSendCode = true;
      this.startCountdown();
    }
  },
  beforeDestroy() {
    this.clearCountdown();
  },
  methods: {
    // 启动倒计时
    startCountdown() {
      this.clearCountdown();
      this.timeInterval = setInterval(() => {
        if (this.count <= 0) {
          this.resetCountdown();
        } else {
          this.count--;
          this.$store.commit("updateSendCodeCountState", this.count);
        }
      }, 1000);
    },

    // 清除定时器
    clearCountdown() {
      if (this.timeInterval) {
        clearInterval(this.timeInterval);
        this.timeInterval = null;
      }
    },

    // 重置倒计时
    resetCountdown() {
      this.clearCountdown();
      this.isSendCode = false;
      this.count = COUNTDOWN_TOTAL;
      this.$store.commit("updateSendCodeCountState", this.count);
    },

    // 清空表单
    resetForm() {
      this.form.user = "";
      this.form.password = "";
      this.form.captcha = "";
      this.form.passwordConfirm = "";
      this.form.verCode = "";
    },

    async submitRegister() {
      const valid = await this.$refs.loginForm.validate().catch(() => false);
      if (!valid) return;

      const isValidUser =
        regexJs.telephone.test(this.form.user) ||
        regexJs.email.test(this.form.user);
      if (!isValidUser) return;

      if (this.form.password !== this.form.passwordConfirm) {
        message.error({
          message: "Passwords does not match!",
          duration: 4000,
          offset: 80,
        });
        return;
      }

      this.$showLoading(false, false, "Loading...");
      this.judgeUserType();

      try {
        const result = await signUp(this.form);
        this.$hideLoading();
        if (result) {
          message.success({
            message: "Sign up successful!",
            duration: 4000,
            offset: 80,
          });
          this.$router.push({ path: "/login" });
        }
      } catch (errorResult) {
        this.$hideLoading();
        message.error({
          message: errorResult,
          duration: 4000,
          offset: 80,
        });
      }
    },

    judgeUserType() {
      this.form.type =
        this.registeredType === "email"
          ? constants.loginNameType.email
          : constants.loginNameType.phone;
    },

    async sendCode() {
      if (!this.form.user || !this.form.captcha) return;

      // 验证用户输入格式
      if (this.registeredType === "email") {
        if (!regexJs.email.test(this.form.user)) {
          message.error({
            message: "Incorrect Email",
            duration: 4000,
            offset: 80,
          });
          return;
        }
      } else {
        if (!regexJs.telephone.test(this.form.user)) {
          message.error({
            message: "Incorrect Mobile",
            duration: 4000,
            offset: 80,
          });
          return;
        }
      }

      this.$showLoading(false, false, "Loading...");
      this.judgeUserType();

      try {
        // 验证验证码
        await checkCaptcha({
          captcha: this.form.captcha,
          uuid: this.uuid,
        });

        // 发送验证码
        await getVerificationCode({
          user: this.form.user,
          type: this.form.type,
          sendCodeType: constants.sendCodeType.register,
        });

        this.$hideLoading();
        this.isSendCode = true;
        this.startCountdown();
      } catch (errorResult) {
        this.$hideLoading();
        this.isSendCode = false;
        message.error({
          message: errorResult,
          duration: 4000,
          offset: 80,
        });
        // 验证码错误时刷新
        if (this.form.captcha) {
          this.refreshCode();
        }
      }
    },

    goBack() {
      this.$router.push({ path: "/login" });
    },

    async refreshCode() {
      try {
        const res = await getCaptcha({});
        this.codeUrl = res.img;
        this.uuid = res.uuid;
      } catch (error) {
        message.error({
          message: "Failed, Please try again!",
          duration: 4000,
          offset: 80,
        });
      }
    },

    handleTabClick() {
      this.resetForm();
      this.refreshCode();
    },

    overseasRegisterMail() {
      this.resetForm();
      this.registeredType = "email";
      this.form.type = constants.loginNameType.email;
      this.refreshCode();
      // 清除错误提示
      setTimeout(() => this.$refs.loginForm && this.$refs.loginForm.resetFields(), 20);
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  padding-top: 25px;
  .tit {
    margin-bottom: 50px;
    overflow: hidden;
    h3 {
      float: left;
      font-size: 24px;
      color: #000;
    }
    .wei {
      float: right;
      line-height: 30px;
      color: #7e7e7e;
      font-size: 14px;
      cursor: pointer;
      .iconfont {
        margin-right: 10px;
        color: #5acd54;
        font-size: 16px;
      }
    }
  }
  .login-form {
    .el-form-item {
      &.btn {
        margin: 25px 0;
      }
    }
  }
}
.overseasText {
  float: right;
  line-height: 20px;
  color: #7e7e7e;
  font-size: 10px;
  cursor: pointer;
}
</style>
